// LES CARTES OFFICIELLES RETOUCHÉES (30/07) — côté client.
//
// Le catalogue est EMBARQUÉ dans le bundle (shared/levels-catalog). Une correction faite par
// l'admin depuis l'éditeur vit en base, pas dans le code : sans ce module, elle ne serait visible
// de personne tant qu'un déploiement n'a pas eu lieu.
//
// ⚠️ LA SURCHARGE VAUT POUR TOUT LE MONDE, pas seulement pour l'admin. Si Claude-Alain corrigeait
// une carte impossible et que ses enfants continuaient à jouer l'ancienne, ils compareraient des
// chronos sur deux terrains différents. C'est aussi pourquoi le SLUG ne change pas : les records
// déjà posés restent rattachés à la carte.
//
// ⚠️ DÉGRADATION SILENCIEUSE : hors ligne, ou si l'appel échoue, on garde le catalogue embarqué.
// Le jeu marche, simplement sans les dernières corrections. Jamais d'écran d'erreur pour ça.
import { apiLevelOverrides } from './api'
import type { CatalogEntry } from '../shared/levels-catalog'

export interface OverrideDto {
  slug: string; rows: string[]; decor: string; world: string
  monkSpeed: string; smartMonks: number; monkPowers: number; updatedAt: string
}

let charge: Map<string, OverrideDto> | null = null

/** Récupère les surcharges. Best-effort : une panne réseau laisse le catalogue d'origine. */
export async function chargerOverrides(): Promise<void> {
  try {
    const r = await apiLevelOverrides()
    charge = new Map(r.overrides.map((o) => [o.slug, o]))
  } catch {
    charge = null
  }
}

/** Vrai si cette carte officielle a été retouchée (sert à le DIRE dans l'éditeur). */
export function estRetouchee(slug: string): boolean {
  return charge?.has(slug) ?? false
}

/**
 * Applique les surcharges à une liste de cartes du catalogue.
 *
 * Les champs vides ou à -1 veulent dire « garder la valeur du catalogue » : une correction qui ne
 * touche que la grille ne doit pas remettre à zéro la vitesse des moines ou le biome.
 */
export function appliquerOverrides(levels: readonly CatalogEntry[]): CatalogEntry[] {
  if (!charge || charge.size === 0) return [...levels]
  return levels.map((l) => {
    const o = charge!.get(l.slug)
    if (!o) return l
    return {
      ...l,
      rows: o.rows,
      decor: o.decor !== '' ? o.decor : l.decor,
      world: (o.world !== '' ? o.world : l.world) as CatalogEntry['world'],
      monkSpeed: (o.monkSpeed !== '' ? o.monkSpeed : l.monkSpeed) as CatalogEntry['monkSpeed'],
      smartMonks: o.smartMonks >= 0 ? o.smartMonks === 1 : l.smartMonks,
      monkPowers: o.monkPowers >= 0 ? o.monkPowers === 1 : l.monkPowers,
    }
  })
}
